module.exports = __webpack_public_path__ + "img/inactive.1f3ca858.png";